import { useNavigate } from "react-router"

export const NavigateService = (url: string) => {
    const navigation = useNavigate()
    navigation(url)
}